import { createApi } from "@reduxjs/toolkit/query/react";
import { appId, proctoringApiBaseUrl, xClientVersion } from "config/constant";
import type { RootState } from "store/store";
import mixpanel from "config/mixpanel";
import { createBaseQueryWithServerTimeSync } from "helpers/base-query";

export interface AlertApiPayload {
  alert_type_id: number;
  description: string;
  timestamp: string;
  payload?: { file: string } | { extend_time: number; extend_reason: string };
  keepalive?: boolean;
}
export const alertApi = createApi({
  reducerPath: "alert",
  baseQuery: createBaseQueryWithServerTimeSync({
    baseUrl: proctoringApiBaseUrl,
    prepareHeaders: (headers: Headers, { getState }) => {
      const session = (getState() as RootState).app.session;
      headers.set("app-id", appId as string);
      headers.set("session-token", session.session_token!);
      headers.set("x-talview-client-version", xClientVersion);
    }
  }),
  endpoints: (builder) => ({
    createAlert: builder.mutation({
      query: (payload: AlertApiPayload) => {
        const { keepalive, ...apiPayload } = payload;
        mixpanel.track(apiPayload.description);
        return {
          url: "v1/alert",
          method: "POST",
          keepalive: Boolean(keepalive),
          body: apiPayload
        };
      },
      transformResponse(response: any) {
        return response;
      },
      transformErrorResponse(errorResponse: any) {
        return errorResponse?.data?.message;
      }
    })
  })
});

export const { useCreateAlertMutation } = alertApi;
